import AppLayout from '../../layout/AppLayout';
import AppAccordion from '../AppAccordion';
import AppContainer from '../AppContainer/AppContainer';
import AppHead from '../AppHead';

export default function faq({ page }) {
  return (
    <AppLayout localesUrls={page.language_urls}>
      <AppHead
        metaTitle={page.meta?.title}
        metaDescription={page.meta?.description}
        language_urls={page.language_urls}
      />
      <AppContainer>
        <AppAccordion title={page?.title} subTitle={page?.sub_title} data={page.data} />
      </AppContainer>
    </AppLayout>
  );
}
